import * as React from "react";
const SvgBreakoutRoom = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.252 13.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
      fill="currentColor"
    />
    <path
      d="M14.446 6.16A2.25 2.25 0 0 1 16.694 4h2.115c1.207 0 2.2.953 2.248 2.16l.174 4.34c.001.04.023.078.058.1a2.493 2.493 0 0 1 1.211 2.137v1.137c0 .91-.463 1.713-1.167 2.184l.65 3.035a.75.75 0 0 1-1.466.314l-.623-2.907H15.606l-.623 2.907a.75.75 0 1 1-1.466-.314l.65-3.037a2.623 2.623 0 0 1-1.164-2.182v-1.137c0-.876.46-1.687 1.21-2.138a.122.122 0 0 0 .06-.1l.173-4.339Zm2.248-.66a.75.75 0 0 0-.749.72l-.174 4.34a1.622 1.622 0 0 1-.786 1.325.993.993 0 0 0-.482.852v1.137c0 .622.504 1.126 1.126 1.126h4.245c.622 0 1.126-.504 1.126-1.126v-1.137a.993.993 0 0 0-.482-.852 1.621 1.621 0 0 1-.786-1.325l-.174-4.34a.75.75 0 0 0-.75-.72h-2.114ZM4.752 5.182a1.583 1.583 0 0 0-2.237-.965 1.86 1.86 0 0 0-.995 1.94l1.098 7.161a3.741 3.741 0 0 0 1.136 2.162l-.774 3.613a.75.75 0 1 0 1.467.314l.666-3.108c.381.13.79.201 1.212.201h3.319l.623 2.907a.75.75 0 1 0 1.466-.314l-.638-2.978c.4-.32.655-.813.655-1.365v-1.5A2.75 2.75 0 0 0 9 10.5H6.5a.25.25 0 0 1-.24-.18L4.752 5.182Zm-1.556.372a.083.083 0 0 1 .117.05l1.507 5.138A1.75 1.75 0 0 0 6.499 12H9c.69 0 1.25.56 1.25 1.25v1.5A.25.25 0 0 1 10 15H6.325a2.25 2.25 0 0 1-2.224-1.909L3.003 5.93a.36.36 0 0 1 .193-.376Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBreakoutRoom;
